import styled from 'vue-styled-components';

import theme from '@/config/theme';

export const Container = styled.main`
  display: flex;
  flex-direction: column;
  gap: 62px;
  padding-top: 140px;
  .accordionContainer {
    padding: 1rem 1.5rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;

    .accordionItem {
      position: relative;
      display: flex;
      width: 100%;

      p {
        flex-basis: 100%;
        color: ${theme.colors.gray6};
        font-size: 0.9rem;
        align-self: center;
        font-weight: 400;

        display: block;
        max-width: 75%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        svg {
          width: 15px;
          height: 15px;
          color: ${theme.colors.primaryBlue};

          :hover {
            transform: scale(1.1);
          }
        }
      }

      ::before {
        position: absolute;
        display: inline-block;
        content: "";
        border-top: 1px solid ${theme.colors.gray2};
        width: 100%;
        left: 0;
        transform: translateY(-1rem);
      }

      &:first-child {
        margin-top: 0.5rem;
        background-color: ${theme.colors.grayBg};
      }

      &:first-child::before {
        content: none;
      }

      &.spaceBetween {
        justify-content: space-between;

        p {
          flex-basis: auto;
        }
      }
    }
  }
`;

export const TableDetail = styled.div`
border-radius: 8px;
max-height: 70vh;
margin-top: 5px;
display: block;
overflow: auto;
table {
  width: 100%;
  overflow-x: auto;
  overflow-y: auto;
  .agent th:first-child {
    width: 40%;
  }
  th:first-child {
    width: 35%;
  }
  th:last-child {
    width: 70;
  }
}
h2{
  color: white;
}
thead {
  background: #FFFFFF;
  box-shadow: inset 0px -1px 0px #e6e7edb3;
  opacity: 1;
  height: 44px;
}
th {
  text-align: left;
  border-left: 1px solid #F1F2F0;
  font-weight: 600;
  font-size: 16px;
  color: white;
  text-align: left;
  padding: 16px 10px;
  background-color: #7B33E2;
}
th span {
  display: flex;
  width: 100%;
}
.th_field {
  width: 90%;
}
.icon_field {
  display: none !important;
  width: 4%;
  cursor: pointer;
}
tr {
  height: 48px;
  background: #FFFFFF;
  box-shadow: inset 0px -1px 0px #E7E7EDB3;
}
td {
  text-align: left;
  border-left: 1px solid #F1F2F0;
  padding: 15px 25px;
}
td:nth-last-child(2) {
  span{
    padding: 5px;
    border-radius: 10px;
    background-color: rgba(0, 255, 0, 0.2);
  }
}
::-webkit-scrollbar {
  height: 10px;
  width: 4px;
  border: 1px solid #d5d5d5;
  background-color: white;
  box-shadow: none !important;
  background-image: none !important;
}
.error-message {
  text-align: center;
  margin: 1% 0;
  color: red;
}
.all-display-none {
  display: none;
}`;

export const Main = styled.main`
  display: grid;
  gap: 16px;
  grid-template-columns: 1fr;
  padding: ${theme.spacings.xxlarge} ${theme.spacings.xxxlarge};

  @media screen and (min-width: ${theme.grid.xltablet.breakpoint}) {
    grid-template-columns: repeat(2, 1fr);
    gap: 60px;
  }
  .filters {
    display: flex;
    align-items: center;
    column-gap: 1rem;
    row-gap: .5rem;
    flex-wrap: wrap;
  }
  > div {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 16px;

    > .block {
      display: flex;

      &.column {
        flex-direction: column;
        gap: ${theme.spacings.medium};
      }

      p {
        font-size: ${theme.font.sizes.p2};
        line-height: ${theme.font.lineHeights.p2};
      }

      p.label {
        color: ${theme.colors.gray5};
        display: flex;
      }

      p.value {
        color: ${theme.colors.gray6};
        margin-left: ${theme.spacings.xxsmall};
      }
    }
  }
  .accordionContainer {
    padding: 1rem 1.5rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;

    .accordionItem {
      position: relative;
      display: flex;
      width: 100%;
      li {
        flex-basis: 100%;
        color: ${theme.colors.gray6};
        font-size: 0.9rem;
        align-self: center;
        font-weight: 400;

        display: block;
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        svg {
          width: 15px;
          height: 15px;
          color: ${theme.colors.primaryBlue};

          :hover {
            transform: scale(1.1);
          }
        }
      }
      p {
        flex-basis: 100%;
        color: ${theme.colors.gray6};
        font-size: 0.9rem;
        align-self: center;
        font-weight: 400;

        display: block;
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        svg {
          width: 15px;
          height: 15px;
          color: ${theme.colors.primaryBlue};

          :hover {
            transform: scale(1.1);
          }
        }
      }

      ::before {
        position: absolute;
        display: inline-block;
        content: "";
        border-top: 1px solid ${theme.colors.gray2};
        width: 100%;
        left: 0;
        transform: translateY(-1rem);
      }

      &:first-child {
        margin-top: 0.5rem;
        background-color: ${theme.colors.grayBg};
      }

      &:first-child::before {
        content: none;
      }

      &.spaceBetween {
        justify-content: space-between;

        p {
          flex-basis: auto;
        }
      }
    }
  }
`;

export const ContentDocs = styled.div`
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  grid-auto-rows: auto;
  overflow: hidden;
  padding: ${theme.spacings.xxlarge} ${theme.spacings.xxxlarge};
  background-color: #fff;
  box-sizing: ${theme.shadow.small};
  border-radius: ${theme.border.radius.small};

  > div {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 16px;

    > .block {
      display: flex;
      flex-direction: column;
      row-gap: 1rem;

      > div {
        display: flex;
        justify-content: space-between;
        width: 100%;

        p {
          font-size: max(0.9rem, 1.2vw);
        }

        a {
          font-size: ${theme.font.sizes.p2};
          color: ${theme.colors.gray6};

          &:hover {
            text-decoration: underline;
          }

          &.flex {
            display: flex;
            align-items: center;
            column-gap: 0.5rem;
          }
          &.flexPix {
            display: flex;
            align-items: center;
            column-gap: .5rem;
            position: absolute;
            left: 80%;
            margin-top: 8px;
          }
        }
      }
    }
  }
`;
